import {useAuthStore} from "../store/auth.store";
import {useEffect, useState} from "react";
import {useEventsStore} from "../store/events.store";
import {PartnerApi} from "../api/partner.api";
import {NavLink, useParams} from "react-router";
import {useEvent} from "../hook/partner/event.partner.hook";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import { useTranslation } from "../hooks/useTranslation";

function Event() {
    const { t } = useTranslation();
    const {eventId} = useParams();

    const eventMutation = useEvent();

    const token = useAuthStore((state) => state.token);
    const event = useEventsStore((state) => state.event);

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);

    const [page, setPage] = useState("produkty");

    useEffect(()=>{
        setPagename(event?event.name:"");
        setBreadcrumbs([
            {
                name: t("events.calendar"),
                link: "/akce",
            }
        ]);
    },[event]);

    useEffect(() => {
        if (token && eventId) {
            eventMutation.mutate(
                {token, id:eventId}
            )
        }
    }, [token, eventId]);

    if (eventMutation.isLoading) {
        return <p>{t("common.loading")}</p>;
    }

    if (!event) {
        return <></>;
    }

    if (event.event_id != eventId) {
        return <></>;
    }

    return (
        <>
            <div className="row">
                <div className="col-md-4">
                    <div className="card p-4  mb-10">
                        {event.vendor?.length > 0 && (
                            <img className="mw-100"
                                 style={{
                                     aspectRatio: '1 / 1',
                                     objectFit: 'contain',
                                 }}
                                 src={PartnerApi.url + '/vendor/' + event.vendor[0].vendor_id + '/logo.jpg'}
                                 alt={event.name}/>
                        )}

                    </div>
                    <table className="table mb-10">
                        <tbody>
                        <tr>
                            <td>
                                <strong>
                                    {t("events.dateTime")}:
                                </strong>
                            </td>
                            <td className="text-end">
                                {event.sameDay ? (
                                    <>
                                        {(new Date(event.date_start)).toLocaleDateString()}&nbsp;
                                        {(new Date(event.date_start)).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}&nbsp;-&nbsp;
                                        {(new Date(event.date_end)).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </>
                                ) : (
                                    <>
                                        {(new Date(event.date_start)).toLocaleDateString()}&nbsp;
                                        {(new Date(event.date_start)).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}&nbsp;
                                        -&nbsp;
                                        {(new Date(event.date_end)).toLocaleDateString()}&nbsp;
                                        {(new Date(event.date_end)).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>
                                    {t("events.place")}:
                                </strong>
                            </td>
                            <td className="text-end">
                                {event.location}
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <a href={event.registration_url} target="_blank"
                       rel="noopener noreferrer"
                       className="btn btn-primary me-4">{t("events.register")}</a>
                </div>
                <div className="col-md-8">
                    <h1 className="mb-8">{event.name}</h1>
                    <div className="card p-8">

                        <div dangerouslySetInnerHTML={{__html: event.description}}/>
                    </div>
                </div>
            </div>

        </>
    );
}

export default Event;
